import React, { useEffect, useState } from 'react';
import Header from '../../../Header/Header';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
    getAgreementsByProviderIdAndAccountId,
    getConnectionsByProviderId,
    getProviderDetails,
    resetAllData,
    saveVisibilityConnections,
    storeNewConnectionId,
    updateOtherAgreements,
    updateOtherConnectionStatus,
    updateIndividualVendorAgreement
} from '../../store/actions';
import { setCurrentPage, updateSession } from '../../../../store/actions';
import * as Constants from '../../../../constants/Constants';
import { validateWriteAccess } from '../../../Common/ResourceAccessValidation/ResourceAccessValidation';
import baseCSS from 'components/TrustCenter/TrustCenter.module.css';
import classes from './AgreementDetailVendor.module.css';
import cs from 'classnames';
import { FormControlLabel, Grid, Paper, Typography } from '@material-ui/core';
import { Select } from '@tcx/ttc-ui-storybook/dist/components/select/select';
import { Button } from '@tcx/ttc-ui-storybook/dist/components/button/button';
import { PrimarySwitch } from '../../../../theme/CommonTheme';
import {
    isBlank,
    isNotBlank,
    isNotEmptyList,
    isNotEmptyObject
} from '../../../Common/Utils/StringUtils';
import Spinner from '../../../UI/Spinner/Spinner';
import { event } from 'components/Common/Utils/ReactGa4Utils';

const getAgreementList = (agreements) => (Array.isArray(agreements) ? agreements : []);

const AgreementDetailVendor = (props) => {
    const {
        connectionType,
        id,
        activity,
        getConnectionsByProviderId,
        selectedConnection,
        session,
        agreements,
        selectedAccount,
        showSpinner,
        updateOtherAgreements,
        newConnectionId,
        storeNewConnectionId,
        setCurrentPage,
        sidebarResource,
        getProviderDetails,
        selectedProvider,
        saveVisibilityConnections,
        getAgreementsByProviderIdAndAccountId,
        updateSession,
        resetAllData,
        updateOtherConnectionStatus,
        updateIndividualVendorAgreement
    } = props;

    const isSystemAdmin = session.userRole === Constants.SYSTEM_ADMIN;
    const [isWriteAccessGranted, setWriteAccessGranted] = useState(false);
    const initialAgreementData = {
        connection: {
            type: Constants.CONNECTION_TYPES.VENDOR,
            provider_id: Constants.ACTIVITY_TYPE_CREATE === activity ? id : '',
            name: '',
            status: true
        },
        agreements: []
    };
    const [agreementData, setAgreementData] = useState(initialAgreementData);
    const [selectedDataType, setSelectedDataType] = useState(Constants.ACCOUNT_TYPE_DVIR);
    const [isSaveEnabled, setSaveEnabled] = useState(false);
    const [newlyAddedAgreementTypes, setNewlyAddedAgreementTypes] = useState([]);

    useEffect(() => {
        setWriteAccessGranted(
            validateWriteAccess(
                sidebarResource,
                Constants.TRUSTCENTER_RESOURCE,
                Constants.TRUSTCENTER_FEATURE
            )
        );
    }, [sidebarResource]);

    useEffect(() => {
        setCurrentPage(Constants.CREATE_CONNECTION);
    }, [setCurrentPage]);

    useEffect(() => {
        getProviderDetails(id);
        if (Constants.ACTIVITY_TYPE_CREATE === activity) {
            getConnectionsByProviderId(id, connectionType, session);
        } else {
            getConnectionsByProviderId(id, connectionType, session);
            getAgreementsByProviderIdAndAccountId(
                id,
                !isBlank(session.selected_accountId)
                    ? session.selected_accountId
                    : session.accountId
            );
        }
    }, [id]);

    useEffect(() => {
        if (isNotEmptyObject(selectedProvider)) {
            let tempAgreementData = JSON.parse(JSON.stringify(agreementData));
            tempAgreementData.connection.name = selectedProvider.name;
            setAgreementData({ ...tempAgreementData });
        }
    }, [selectedProvider]);

    useEffect(() => {
        getAgreementsByProviderIdAndAccountId(
            id,
            !isBlank(session.selected_accountId) ? session.selected_accountId : session.accountId
        );
    }, [activity]);

    useEffect(() => {
        if (isNotEmptyObject(selectedConnection)) {
            let tempAgreementData = JSON.parse(JSON.stringify(agreementData));
            tempAgreementData.connection = selectedConnection;
            setAgreementData({ ...tempAgreementData });
            updateSession({ connectionId: selectedConnection.id });
            props.history.push(`/agreements/${connectionType}/${id}/edit`);
        }
    }, [selectedConnection]);

    useEffect(() => {
        if (Array.isArray(agreements)) {
            let tempAgreementData = JSON.parse(JSON.stringify(agreementData));
            tempAgreementData.agreements = agreements;
            setAgreementData({ ...tempAgreementData });
        }
    }, [agreements]);

    useEffect(() => {
        isNotBlank(newConnectionId) && storeNewConnectionId('');
        isNotBlank(newConnectionId) &&
            props.history.push(`/agreements/${connectionType}/${id}/edit`);
    }, [newConnectionId]);

    useEffect(() => {
        setSaveEnabled(
            getAgreementList(agreementData.agreements).length > getAgreementList(agreements).length
        );
    }, [agreementData.agreements, agreements]);

    const emptyPanel = (message) => {
        return (
            <React.Fragment>
                <div>
                    <Typography className={classes.emptyText}>{message}</Typography>
                </div>
            </React.Fragment>
        );
    };

    const navigateToSummary = () => {
        resetAllData(true);
        if (isSystemAdmin) {
            props.history.push(`/connections?accountId=${selectedAccount.id}`);
        } else {
            props.history.push(`/connections`);
        }
    };

    const handleDataTypeChange = () => {
        // const { value } = event.target;
        let tempAgreements = JSON.parse(JSON.stringify(agreementData));
        let tempArray = getAgreementList(tempAgreements.agreements);
        let newAgreementPOJO = {
            agreement_type: selectedDataType.toUpperCase(),
            status: true
        };
        if (isNotBlank(tempAgreements.connection.id)) {
            newAgreementPOJO.connection_id = tempAgreements.connection.id;
        }
        const isExistingAgremeent = tempArray.some(
            (row) => row.agreement_type === selectedDataType.toUpperCase()
        );
        if (!isExistingAgremeent) {
            tempArray.push(newAgreementPOJO);
            tempAgreements.agreements = tempArray;
            setAgreementData({ ...tempAgreements });
        }
        setNewlyAddedAgreementTypes([...newlyAddedAgreementTypes, selectedDataType.toUpperCase()]);
    };

    const handleToggle = (event, type) => {
        updateIndividualVendorAgreement(agreementData?.connection, type, event.target.checked);
    };

    const getStatus = (type) => {
        const findAgreement = getAgreementList(agreementData.agreements).find(
            (row) => row.agreement_type === type
        );
        return findAgreement ? findAgreement.status : true;
    };

    const handleSave = () => {
        event('VendorAgreement', 'VendorAgreementUpdated', `${session.accountName}`);
        if (Constants.ACTIVITY_TYPE_CREATE === activity) {
            saveVisibilityConnections(agreementData, id, connectionType);
        } else {
            const agreementList = getAgreementList(agreementData.agreements);
            const connId = isNotBlank(session.connectionId)
                ? session.connectionId
                : agreementList[0]?.connection_id;
            updateOtherAgreements(connId, id, agreementList);
        }
        setNewlyAddedAgreementTypes([]);
    };

    const handleCancel = () => {
        let tempAgreementData = JSON.parse(JSON.stringify(agreementData));
        tempAgreementData.agreements = getAgreementList(agreements);
        setAgreementData({ ...tempAgreementData });
        setNewlyAddedAgreementTypes([]);
    };

    const toggleConnectionStatus = () => {
        updateOtherConnectionStatus(agreementData?.connection, !agreementData?.connection?.status);
    };

    const fuelTaxComponent = (
        <React.Fragment>
            <div className={classes.componentMargin}>
                <Paper elevation={0}>
                    <div className={cs('base-margin', classes.agreementBackground)}>
                        <Grid container justify={'space-between'}>
                            <Grid item>
                                <Typography className={classes.agreementTitle}>Fuel Tax</Typography>
                            </Grid>
                            <Grid item>
                                <FormControlLabel
                                    control={
                                        <PrimarySwitch
                                            checked={getStatus(Constants.AGREEMENT_TYPE_FUEL_TAX)}
                                            name="checkedB"
                                            color="primary"
                                            id="agreement_fuelTax_status_toggle"
                                            value={getStatus(Constants.AGREEMENT_TYPE_FUEL_TAX)}
                                            onChange={(e) =>
                                                handleToggle(e, Constants.AGREEMENT_TYPE_FUEL_TAX)
                                            }
                                            disabled={
                                                !isWriteAccessGranted ||
                                                newlyAddedAgreementTypes.includes(
                                                    Constants.AGREEMENT_TYPE_FUEL_TAX
                                                )
                                            }
                                        />
                                    }
                                    label={
                                        getStatus(Constants.AGREEMENT_TYPE_FUEL_TAX).toString() ===
                                        Constants.TRUE
                                            ? 'Active'
                                            : 'Inactive'
                                    }
                                />
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Typography>{Constants.FUEL_TAX_TEXT_1}</Typography>
                            <Typography>{Constants.FUEL_TAX_TEXT_2}</Typography>
                        </Grid>
                    </div>
                </Paper>
            </div>
        </React.Fragment>
    );

    const ctaComponent = (
        <React.Fragment>
            <div className={classes.componentMargin}>
                <Paper elevation={0}>
                    <div className={cs('base-margin', classes.agreementBackground)}>
                        <Grid container justify={'space-between'}>
                            <Grid item>
                                <Typography className={classes.agreementTitle}>
                                    Cycle Time Availability
                                </Typography>
                            </Grid>
                            <Grid item>
                                <FormControlLabel
                                    control={
                                        <PrimarySwitch
                                            checked={getStatus(Constants.AGREEMENT_TYPE_CTA)}
                                            name="checkedB"
                                            color="primary"
                                            id="agreement_cta_status_toggle"
                                            value={getStatus(Constants.AGREEMENT_TYPE_CTA)}
                                            onChange={(e) =>
                                                handleToggle(e, Constants.AGREEMENT_TYPE_CTA)
                                            }
                                            disabled={
                                                !isWriteAccessGranted ||
                                                newlyAddedAgreementTypes.includes(
                                                    Constants.AGREEMENT_TYPE_CTA
                                                )
                                            }
                                        />
                                    }
                                    label={
                                        getStatus(Constants.AGREEMENT_TYPE_CTA).toString() ===
                                        Constants.TRUE
                                            ? 'Active'
                                            : 'Inactive'
                                    }
                                />
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Typography>{Constants.CTA_TEXT}</Typography>
                        </Grid>
                    </div>
                </Paper>
            </div>
        </React.Fragment>
    );

    const dvirComponent = (
        <React.Fragment>
            <div className={classes.componentMargin}>
                <Paper elevation={0}>
                    <div className={cs('base-margin', classes.agreementBackground)}>
                        <Grid container justify={'space-between'}>
                            <Grid item>
                                <Typography className={classes.agreementTitle}>DVIR</Typography>
                            </Grid>
                            <Grid item>
                                <FormControlLabel
                                    control={
                                        <PrimarySwitch
                                            checked={getStatus(Constants.ACCOUNT_TYPE_DVIR)}
                                            name="checkedB"
                                            color="primary"
                                            id="agreement_dvir_status_toggle"
                                            value={getStatus(Constants.ACCOUNT_TYPE_DVIR)}
                                            onChange={(e) =>
                                                handleToggle(e, Constants.ACCOUNT_TYPE_DVIR)
                                            }
                                            disabled={
                                                !isWriteAccessGranted ||
                                                newlyAddedAgreementTypes.includes(
                                                    Constants.ACCOUNT_TYPE_DVIR
                                                )
                                            }
                                        />
                                    }
                                    label={
                                        getStatus(Constants.ACCOUNT_TYPE_DVIR).toString() ===
                                        Constants.TRUE
                                            ? 'Active'
                                            : 'Inactive'
                                    }
                                />
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Typography>{Constants.DVIR_DETAIL_TEXT}</Typography>
                        </Grid>
                    </div>
                </Paper>
            </div>
        </React.Fragment>
    );

    const driverComponent = (
        <React.Fragment>
            <div className={classes.componentMargin}>
                <Paper elevation={0}>
                    <div className={cs('base-margin', classes.agreementBackground)}>
                        <Grid container justify={'space-between'}>
                            <Grid item>
                                <Typography className={classes.agreementTitle}>DRIVER</Typography>
                            </Grid>
                            <Grid item>
                                <FormControlLabel
                                    control={
                                        <PrimarySwitch
                                            checked={getStatus(Constants.ACCOUNT_TYPE_DRIVER)}
                                            name="checkedB"
                                            color="primary"
                                            id="agreement_driver_status_toggle"
                                            value={getStatus(Constants.ACCOUNT_TYPE_DRIVER)}
                                            onChange={(e) =>
                                                handleToggle(e, Constants.ACCOUNT_TYPE_DRIVER)
                                            }
                                            disabled={
                                                !isWriteAccessGranted ||
                                                newlyAddedAgreementTypes.includes(
                                                    Constants.ACCOUNT_TYPE_DRIVER
                                                )
                                            }
                                        />
                                    }
                                    label={
                                        getStatus(Constants.ACCOUNT_TYPE_DRIVER).toString() ===
                                        Constants.TRUE
                                            ? 'Active'
                                            : 'Inactive'
                                    }
                                />
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Typography>{Constants.DRIVER_DETAIL_TEXT}</Typography>
                        </Grid>
                    </div>
                </Paper>
            </div>
        </React.Fragment>
    );

    const getComponent = (type) => {
        switch (type.toUpperCase()) {
            case Constants.ACCOUNT_TYPE_DVIR:
                return dvirComponent;
            case Constants.AGREEMENT_TYPE_FUEL_TAX:
                return fuelTaxComponent;
            case Constants.AGREEMENT_TYPE_CTA:
                return ctaComponent;
            case Constants.ACCOUNT_TYPE_DRIVER:
                return driverComponent;
            default:
                return null;
        }
    };

    return (
        <React.Fragment>
            <Header title="PROVIDER DETAIL" />
            <Paper className={isSystemAdmin ? classes.customToolBar : null}>
                <div className={cs('row no-gutters', baseCSS.subHeader)}>
                    <Grid container>
                        <Grid item xs={5}>
                            <div className={baseCSS.backNavigation}>
                                <Typography
                                    className={baseCSS.backNavigation}
                                    id={'backToConnectionsBtn'}
                                    onClick={navigateToSummary}
                                >
                                    <i
                                        className={cs(
                                            'fas fa-arrow-left',
                                            baseCSS.backNavigationIcon
                                        )}
                                    />
                                    Back to Connections
                                </Typography>
                            </div>
                        </Grid>
                        <Grid item xs={7}>
                            <div id={'pageTitle'}>
                                {isSystemAdmin ? selectedAccount.name : session.accountName}
                            </div>
                        </Grid>
                    </Grid>
                </div>
                <div className={cs('base-margin', classes.parentBaseMargin)}>
                    <Paper elevation={0}>
                        <div className={cs(classes.base)}>
                            {!showSpinner ? (
                                <div className={cs('row')}>
                                    <div className={cs('col-md-4', classes.leftPanelBase)}>
                                        <div className="base-margin">
                                            <Grid container justify={'space-between'}>
                                                <Grid item>
                                                    <Typography className={classes.agreementTitle}>
                                                        {isBlank(agreementData.connection.name)
                                                            ? 'VENDOR NAME'
                                                            : agreementData.connection.name}
                                                    </Typography>
                                                </Grid>
                                                <Grid item>
                                                    <FormControlLabel
                                                        control={
                                                            <PrimarySwitch
                                                                checked={
                                                                    agreementData.connection.status
                                                                }
                                                                name="checkedB"
                                                                color="primary"
                                                                disabled={
                                                                    !isWriteAccessGranted ||
                                                                    Constants.ACTIVITY_TYPE_CREATE ===
                                                                        activity
                                                                }
                                                                id="agreement_status_toggle"
                                                                value={
                                                                    agreementData.connection.status
                                                                }
                                                                onChange={toggleConnectionStatus}
                                                            />
                                                        }
                                                        label={
                                                            agreementData?.connection?.status?.toString() ===
                                                            Constants.TRUE
                                                                ? 'Active'
                                                                : 'Inactive'
                                                        }
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid container justify={'space-between'}>
                                                <Grid item>
                                                    <Select
                                                        options={Constants.VENDOR_AGREEMENT_TYPES.map(
                                                            (value) => ({
                                                                value: value,
                                                                label: value
                                                            })
                                                        )}
                                                        name={'agreementType'}
                                                        label={'Data Type'}
                                                        value={selectedDataType}
                                                        onChange={(event) =>
                                                            setSelectedDataType(event.target.value)
                                                        }
                                                        disabled={!isWriteAccessGranted}
                                                        id={'agreementTypeId'}
                                                        data-testid="agreementType"
                                                    />
                                                </Grid>
                                                <Grid item className={classes.addButton}>
                                                    <Button
                                                        label={'Add Sharing Agreement'}
                                                        type="secondary-outline-blue"
                                                        onClick={handleDataTypeChange}
                                                        disabled={
                                                            !isWriteAccessGranted ||
                                                            getAgreementList(
                                                                agreementData.agreements
                                                            ).some(
                                                                (agreement) =>
                                                                    agreement?.agreement_type?.toUpperCase() ===
                                                                    selectedDataType?.toUpperCase()
                                                            )
                                                        }
                                                        id={'addBtn'}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </div>
                                    </div>
                                    <div className={cs('col-md-8', classes.PermissionsPanel)}>
                                        {isNotEmptyList(
                                            getAgreementList(agreementData.agreements)
                                        ) ? (
                                            <React.Fragment>
                                                {getAgreementList(agreementData.agreements).map(
                                                    (row) => {
                                                        return getComponent(row.agreement_type);
                                                    }
                                                )}
                                                <div className="base-margin">
                                                    <Grid
                                                        item
                                                        container
                                                        justify="flex-end"
                                                        alignItems="center"
                                                    >
                                                        <div className={classes.cancelBtn}>
                                                            <Button
                                                                label={'CANCEL'}
                                                                variant="text"
                                                                onClick={() => handleCancel()}
                                                                disabled={!isWriteAccessGranted}
                                                            />
                                                        </div>
                                                        <div>
                                                            <Button
                                                                label={'SAVE'}
                                                                type="primary"
                                                                onClick={() => handleSave()}
                                                                disabled={
                                                                    !isWriteAccessGranted ||
                                                                    !isSaveEnabled
                                                                }
                                                                id={'saveBtn'}
                                                            />
                                                        </div>
                                                    </Grid>
                                                </div>
                                            </React.Fragment>
                                        ) : (
                                            <div className="base-margin">
                                                {emptyPanel(Constants.VENDOR_AGREEMENT_EMPTY_TEXT)}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ) : (
                                <Spinner />
                            )}
                        </div>
                    </Paper>
                </div>
            </Paper>
        </React.Fragment>
    );
};

const mapStateToProps = (state) => ({
    session: state.session.sessionValue,
    sidebarResource: state.header.sidebarResource,
    selectedConnection: state.agreement.selectedConnection,
    selectedAccount: state.accounts.selectedAccount,
    agreements: state.agreement.agreements,
    showSpinner: state.agreement.showSpinner,
    newConnectionId: state.agreement.newConnectionId,
    selectedProvider: state.connection.selectedProvider
});

export default withRouter(
    connect(mapStateToProps, {
        getConnectionsByProviderId,
        updateOtherAgreements,
        storeNewConnectionId,
        setCurrentPage,
        getProviderDetails,
        saveVisibilityConnections,
        getAgreementsByProviderIdAndAccountId,
        updateSession,
        resetAllData,
        updateOtherConnectionStatus,
        updateIndividualVendorAgreement
    })(AgreementDetailVendor)
);
